import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/ic_search@2x.png'
import _imports_1 from '@/assets/icon/@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-cb4a00b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "search_input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = ["onKeyup", "placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "search_operation"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_operation_w" }, null, -1))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zhanwei" }, null, -1))

import { ref } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
        isShow: {
            type: Boolean,
            required: false,
            default: false
        },
        placeholder: {
            type: String,
            required: false,
            default: '请输入'
        }
    },
  emits: ['searchInput', 'submit', 'reset'],
  setup(__props, { expose, emit }) {

const props = __props

    

    // 向父组件提交两个方法
    

    const open = ref<Boolean>(false)

    const text = ref<string>('')

    // 搜索框搜索
    const searchInput = () => {
        emit('searchInput', text.value)
    }

    const openCate = () => {
        open.value = true
    }

    // 重置
    const closes = () => {
        open.value = false
        text.value = ''
        emit('reset', text.value)
    }

    // 搜索提交
    const submit = () => {
        open.value = false
        emit('submit', '')
    }

    // 向父组件暴漏数据
    expose({
        text
    })

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
        onKeyup: _withKeys(searchInput, ["enter"]),
        type: "text",
        placeholder: props.placeholder
      }, null, 40, _hoisted_4), [
        [_vModelText, text.value]
      ])
    ]),
    (props.isShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("img", {
            onClick: openCate,
            src: _imports_1,
            alt: ""
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      show: open.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((open).value = $event)),
      round: "",
      position: "bottom",
      style: { height: '80%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _hoisted_8,
        _createElementVNode("div", { class: "footer" }, [
          _createElementVNode("div", {
            class: "footer_close",
            onClick: closes
          }, "重置"),
          _createElementVNode("div", {
            class: "footer_submit",
            onClick: submit
          }, "确定")
        ])
      ]),
      _: 3
    }, 8, ["show"])
  ]))
}
}

})